import {
  CloseOutlined,
  EditOutlined,
  MoreOutlined,
  PushpinFilled,
} from "@ant-design/icons";
import { Dropdown, Space, Switch } from "antd";
import TableAntd from "components/elements/Table/Table";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
const NewsListTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onCancel = () => { },
  onChange = () => { },
  onStatus = () => { },
}) => {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);

  function formatDate(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    if (i18n.language === "en") {
      return date.format("DD/MM/YYYY HH:mm");
    } else {
      return `${date.format(`DD/MM/${date.year() + 543}`)} ${date.format('HH:mm')} น.`;
    }
  }
  const columns = [
    {
      title: <div className="text-table"><PushpinFilled /></div>,
      dataIndex: "pinAnnounce",
      key: "pinAnnounce",
      width: 50,
      render: (text) => {
        if (text === "Y") {
          return <PushpinFilled />;
        }
        return "";
      },
    },
    {
      title: <div className="text-table">{t("news.label.subject")}</div>,
      dataIndex: "subject",
      key: "subject",
      sorter: (a, b) => a.subject.length - b.subject.length,
    },
    {
      title: <div className="text-table">{t("news.label.announce_by")}</div>,
      dataIndex: "announcedBy",
      key: "announcedBy",
      width: 180,
      sorter: (a, b) => a.announcedBy?.name?.length - b.announcedBy?.name?.length,
      render: (_, { announcementBy = {} }) => {
        return announcementBy.name;
      },
    },
    {
      title: (
        <div className="text-table">{t("news.label.announcement_date")}</div>
      ),
      dataIndex: "startAnnounce",
      key: "startAnnounce",
      width: 200,
      sorter: (a, b) => a.startAnnounce.length - b.startAnnounce.length,
      render: (text) => (text ? formatDate(text) : "-"),
    },
    {
      title: <div className="text-table">{t("news.label.audience_group")}</div>,
      dataIndex: "audienceGroup",
      key: "audienceGroup",
      render: (_) => _ ?? "-",
    },
    {
      title: <div className="text-table">{t("news.label.acknowledge")}</div>,
      dataIndex: "acknowledged",
      key: "acknowledged",
      width: 100,
      render: (_, text) => _ ?? "-",
    },
    {
      title: (
        <div className="text-table">{t("news.label.status")}</div>
      ),
      dataIndex: "statusFlag",
      key: "statusFlag",
      align: "center",
      render: (text, record) => (
        <>
          <Switch
            checked={text === "ACTIVE"}
            onChange={(checked) => onStatus(checked, record)}
          />
        </>
      ),
    },
    roles.includes("UPDATE_NEWS_&_POLICY|NEWS") ? {
      title: "",
      key: "action",
      fixed: "right",
      align: "center",
      width: 50,
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                roles.includes("UPDATE_NEWS_&_POLICY|NEWS") && {
                  key: "1",
                  onClick: () => onEdit(record),
                  label: `${t("action.edit")}`,
                  icon: (
                    <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                {
                  key: "2",
                  onClick: () => onCancel(record),
                  label: `${t("action.cancel")}`,
                  icon: (
                    <CloseOutlined
                      style={{ fontSize: "18px", color: "gray" }}
                    />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    } : {},
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      rowKey={(record) => record.announcementNewsId}
      columns={columns}
      onChange={onChange}
      scroll={{ x: true }}
    />
  );
};

export default NewsListTable;
